<template>
  <div class="page container">

        <div class="row hideprint">
         
          <div class="col">
         <nav class="nav">
            <router-link to="/admin/produtos" class="nav-link active"><b>Produtos</b></router-link>
            <router-link to="/admin/lista" class="nav-link active"><b>Lista</b></router-link>
            <router-link to="/admin/pedidos" class="nav-link active"><b>Pedidos</b></router-link>
            <router-link to="/admin/regioesentrega" class="nav-link active"><b>Regiões de Entrega</b></router-link>

          </nav>
          </div>

        </div>

    <div class="row mt-5">
    
      <div class="col">

        <!-- <div v-if="">
        </div> -->
        
        <router-view>
        </router-view>
      </div>

    </div>
    </div>

</template>

<script>


export default {
        

  data(){
    return {
      error:'',
      enviado:false,
      produto:{
        id:false,
        nome:'',
        medida:'',
        incremento:'',
        preco:'',
        disponivel:0,
        informacoesadicionais:'',
      }
    }
  },


}
</script>
